angular.module('jv.candidate.details.urls.factory',[])
    .factory('jvCandidateDetailsUrlFAC', [function(){
        return {
            getCandidatePermViews: '/jhire/modules/candidates/paginate.html?applicationId={0}',
            getWorkflowStepUrl: '../../action/application/{0}/workflowSteps'
        };
    }]);